import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, node, bool, func } from 'prop-types';
import { ArrowRight } from '@magalu/stereo-ui-icons';
import { Container, Label, AttributeList } from './attribute-base.styles';
const AttributeBase = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    label,
    current,
    selected,
    bordered,
    onClick,
    onBlur,
    alignment,
    smoothable,
    showTitle
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "label", "current", "selected", "bordered", "onClick", "onBlur", "alignment", "smoothable", "showTitle"]);

  return /*#__PURE__*/React.createElement(Container, {
    ref: ref,
    onBlur: onBlur,
    tabIndex: 1,
    "data-testid": "attribute-container"
  }, showTitle ? /*#__PURE__*/React.createElement(Label, {
    bordered: bordered,
    alignment: alignment,
    onClick: onClick,
    "data-testid": "attribute-label"
  }, !selected ? `Selecionar ${label}` : /*#__PURE__*/React.createElement("span", null, label, ": ", /*#__PURE__*/React.createElement("strong", null, current)), bordered && /*#__PURE__*/React.createElement(ArrowRight, {
    width: 8,
    height: 12
  })) : null, /*#__PURE__*/React.createElement(AttributeList, _extends({
    alignment: alignment,
    smoothable: smoothable
  }, props), children));
});
AttributeBase.defaultProps = {
  label: '',
  current: '',
  selected: false,
  bordered: false,
  alignment: 'center',
  smoothable: false,
  showTitle: true
};
process.env.NODE_ENV !== "production" ? AttributeBase.propTypes = {
  children: node,
  label: string,
  current: string,
  selected: bool,
  bordered: bool,
  onFocus: func,
  onClick: func,
  onBlur: func,
  alignment: string,
  smoothable: bool,
  showTitle: bool
} : void 0;
AttributeBase.displayName = 'AttributeBase';
export default AttributeBase;